import script from "./xiugaimima.vue?vue&type=script&setup=true&lang=js"
export * from "./xiugaimima.vue?vue&type=script&setup=true&lang=js"

import "./xiugaimima.vue?vue&type=style&index=0&id=2eed48be&lang=less&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2eed48be"]])

export default __exports__